import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_COMPANIES]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_COMPANIES]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_COMPANY]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_COMPANY]: (state, item) => removeItem(state, item)
}
